import ActionCable from "actioncable";

export const createCable = (token) => {
  if (!token) return null;

  const cableUrl = `${process.env.REACT_APP_WEBSOCKET_BASE_URL}/cable?token=${token}`;
  return ActionCable.createConsumer(cableUrl);
};
